// The Help panel: a static `.dlg` (like rename/folder) listing every keyboard
// shortcut and touch gesture in the app. Content lives in the HTML; this module
// only wires open/close and the two entry points — the `?` key (app.js's shared
// keydown) and a button in the ⚙ settings panel's Help section.
export function initHelp({ settingsPanel }) {
  const dlg = document.getElementById('helpDlg');

  function open() { if (!dlg.open) dlg.showModal(); }

  document.getElementById('helpClose').onclick = () => dlg.close();
  document.getElementById('helpOk').onclick = () => dlg.close();

  const rows = settingsPanel.addSection('Help');
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'set-help-btn';
  btn.textContent = 'Keyboard & touch help';
  btn.onclick = () => { settingsPanel.close(); open(); };
  rows.appendChild(btn);

  return { open };
}
